import { render, staticRenderFns } from "./EhrEvaluationConfirm.vue?vue&type=template&id=49346450&scoped=true&lang=pug"
import script from "./EhrEvaluationConfirm.vue?vue&type=script&lang=js"
export * from "./EhrEvaluationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49346450",
  null
  
)

export default component.exports